import { render, staticRenderFns } from "./Favourites.vue?vue&type=template&id=0584d8fe"
import script from "./Favourites.vue?vue&type=script&lang=js"
export * from "./Favourites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0584d8fe')) {
      api.createRecord('0584d8fe', component.options)
    } else {
      api.reload('0584d8fe', component.options)
    }
    module.hot.accept("./Favourites.vue?vue&type=template&id=0584d8fe", function () {
      api.rerender('0584d8fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/Favourites.vue"
export default component.exports